<template lang="pug">
  div(:class="'textblock-img-alternating textblock' +' container-'+this._uid")
    div(v-for="(d, i) in this.articleList" :id="'textblock' + i" :class="i % 2 ? 'block right' : 'block left'")
      div.block-content
        h3.title
          vue-markdown(:source='d.title')
        vue-markdown(:source='d.body' class="body")
      div.block-img
        img(:src="d.image && d.image.src" alt="d.image.alt")
</template>

<script>
import Vue from 'vue'
import sectionBase from '@/components/sections/sectionBase.js'
import anime from 'animejs'

// Storing animation target elements
const animTargets = {
  container: '#container'
}

// component instance
var textblockImgAlternate = Vue.component('textblock-img-alternate', {
  name: 'textblockImgAlternate',
  mixins: [sectionBase],
  props: [],
  data: function () {
    return {
    }
  },
  watch: {
  },
  methods: {
  },
  computed: {
    articleList () {
      let articleData = this.payload.fields.content
      let articles = []

      articleData.forEach((d, n) => {
        // TODO: slug should be url directing router to article like so:  /:page/:article
        articles.push({title: d.fields.title, body: d.fields.body, slug: d.fields.slug, image: {src: d.fields.image.fields.file.url, alt: d.fields.image.fields.title}})
      })

      return articles
    },
    actions () {
      // let component = this

      return {
        SET: () => {
          return anime({
            targets: animTargets.container + this._uid,
            easing: 'easeInOutQuad',
            opacity: [
              { value: '1' }
            ],
            translateX: [
              { value: 0 }
            ],
            translateY: [
              { value: 0 }
            ],
            borderColor: [
              { value: '#F0F0F0' }
            ],
            boxShadow: [
              { value: '0px 0px 10px rgba(211,211,211,1)' }
            ],
            duration: 200,
            begin: function (e) {
              console.log('set')
            },
            complete: function () {
            }
          })
        }
      }
    }
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default textblockImgAlternate
</script>

<style scoped>
  .page-title{

  }
</style>



// WEBPACK FOOTER //
// src/components/sections/textblockImgAlternate.vue